import { useContext } from "react";
import logoCondominioDefaut from "static/cloud21/header/condominio-default.png";
import { Col, Row } from "react-bootstrap";
import CustomModal from "shared/components/modal/CustomModal";
import InputSearch from "shared/components/input/InputSearch";
import { UserContext } from "context/UserContext";

import ListagemSelecaoCondominioContexto from "./ListagemSelecaoCondominioContexto";
import usePostSetarContextoAdministradora from "hooks/condominio/usePostSetarContextoAdministradora";
import { FaMapMarkerAlt } from "react-icons/fa";

const SeletorCondominioContexto = () => {
  const {
    usuarioLogado,
    showModalSelecionarCondominioContexto,
    openCloseModalSelecionarCondominioContexto,
    changeQueryCondominioContexto,
  } = useContext(UserContext);

  const { setarContextoAdministradora } = usePostSetarContextoAdministradora();

  const renderCardAdm = () => {
    const alterarContextoParaAdministradora = async () => {
      await setarContextoAdministradora();
      openCloseModalSelecionarCondominioContexto();
    };

    return (
      <Row key={`contextoADM`}>
        <div className="selecionar-condominio condominio-card" onClick={() => alterarContextoParaAdministradora()}>
          <Col sm="1" className="center-align">
            <img className="client-avatar" src={logoCondominioDefaut} alt="" style={{ height: 30, width: 30 }} />
          </Col>
          <Col sm="10" className="header-label">
            {usuarioLogado.clienteGroup || "-"}
          </Col>
          <Col sm="1" className="center-align">
            {usuarioLogado.isContextoAdministradora &&
              <FaMapMarkerAlt color="#FF4BA8" fontSize={"1.5em"} />
            }
          </Col>
        </div>
      </Row>
    );
  };

  const renderModalCondominio = () => {
    const visualizarContextoAdm = usuarioLogado.visualizarContextoAdm || usuarioLogado.isContextoAdministradora;

    return (
      <CustomModal
        showModal={showModalSelecionarCondominioContexto}
        size="sm"
        tipoModal="MODAL_CENTRAL"
        renderHeaderModal={false}
        fecharModalAoClicarFora
        onCloseModal={() => openCloseModalSelecionarCondominioContexto()}
        bodyClassName="condominio-modal"
      >
        <div>
          {visualizarContextoAdm && renderCardAdm()}
          <Row>
            <Col sm={12} className="m-b m-t">
              <InputSearch
                id="filtrarCondominioContexto"
                onSearchChange={(query: string) => changeQueryCondominioContexto(query)}
                placeholder="Buscar condomínio pela Razão social, Nome fantasia/Apelido ou CNPJ"
              />
            </Col>
            <ListagemSelecaoCondominioContexto />
          </Row>
        </div>
      </CustomModal>
    );
  };

  return <div>{renderModalCondominio()}</div>;
};

export default SeletorCondominioContexto;
